import { combineReducers, createFeature } from '@ngrx/store';

import { childSurveysReducer } from './survey-list/reducers/child-surveys.reducer';
import { surveyQueryReducer } from './survey-list/reducers/survey-query.reducer';
import { bulkOpeartionReducer } from './bulk-edit/reducers/bulk-operation.reducer';
import { surveyReferenceReducer } from './reference/survey-reference.reducer';
import { supplierReducer } from './supplier/supplier.reducer';
import { SurveyState } from './survey-state.model';

export const surveyFeatureKey = 'survey';

const surveyReducer = combineReducers<SurveyState>({
  query: surveyQueryReducer,
  children: childSurveysReducer,
  bulkOperation: bulkOpeartionReducer,
  reference: surveyReferenceReducer,
  supplier: supplierReducer,
});

export const surveyFeature = createFeature({
  name: surveyFeatureKey,
  reducer: surveyReducer,
});
